export const exportImageScaleFactor = 2;

export const exportImageUnit = 'mm';

export const headerBackgroundColor = '#07101d';
export const darkModeDiagramBackgroundColor = '#0f213a';
export const lightModeDiagramBackgroundColor = '#ffffff';

export const imageSizes = {
  a4: {
    headerImageHeight: {
      landscape: 10,
      portrait: 7,
    },
    imageWidth: {
      landscape: 297,
      portrait: 210,
    },
    topologyTitleOverflowCoordinate: {
      landscape: 287,
      portrait: 200,
    },
  },
  letter: {
    headerImageHeight: {
      landscape: 9,
      portrait: 7,
    },
    imageWidth: {
      landscape: 279.4,
      portrait: 215.9,
    },
    topologyTitleOverflowCoordinate: {
      landscape: 270,
      portrait: 206,
    },
  },
  tabloid: {
    headerImageHeight: {
      landscape: 14,
      portrait: 9,
    },
    imageWidth: {
      landscape: 432,
      portrait: 279.4,
    },
    topologyTitleOverflowCoordinate: {
      landscape: 420,
      portrait: 270,
    },
  },
};

export const siteTitle = 'dCloud Topology Builder';
